import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, ListGroup, Badge } from "react-bootstrap";
import S3ImageLoader from '../../S3ImageLoader';
import S3PdfViewer from '../../S3PdfViewer';



export default function PrintReport({print,setPrint,imageUrl}) {
    return (
        <Modal show={print} onHide={() => setPrint(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>Test Report</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <S3PdfViewer fileName={imageUrl} />
            </Modal.Body>
        </Modal>
    )
}
